import { render, staticRenderFns } from "./newdictiona.vue?vue&type=template&id=e7639cc8&scoped=true&"
import script from "./newdictiona.vue?vue&type=script&lang=js&"
export * from "./newdictiona.vue?vue&type=script&lang=js&"
import style0 from "./newdictiona.vue?vue&type=style&index=0&id=e7639cc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7639cc8",
  null
  
)

export default component.exports